import React, { Component } from 'react';

import { DocumentSectionListEditor } from './DocumentSectionListEditor';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

class DocumentEditor extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { document, save } = this.props;

        return (
            <div>
                <Formik
                    initialValues={document}
                    onSubmit={(values, { setFieldError }) => {
                        try {
                            save(values);
                        } catch (errors) {
                            // Catch status code > 299
                            errors.forEach(err => {
                                setFieldError(err.field, err.error); // Map errors to fields
                            });
                        }
                    }}
                    validate={values => {
                        const errors = {};

                        if (!values.name) {
                            errors.name = 'Required';
                        }

                        if (!values.url) {
                            errors.url = 'Required';
                        }

                        return errors;
                    }}
                    component={this.form}
                />
            </div>
        );
    }

    canSaveDocument = () => {
        const { document } = this.props;
        if (document) {
            const lockedStatuses = ['ANALYSIS_IN_PROGRESS', 'ANALYSIS_COMPLETE'];
            const { status = null } = document;

            return lockedStatuses.includes(status);
        }
    };

    form = ({ handleSubmit, values, touched, handleChange, errors }) => {
        const handleSectionChange = sectionRows => {
            let sections = sectionRows.map(section => {
                return { sectionXpath: section.xpath, sectionNote: section.comment };
            });
            sections.pop(); // Remove the last row which is the blank "new entry" row
            values.sections = sections;
        };

        return (
            <form onSubmit={handleSubmit} className="needs-validation">
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        placeholder="Name"
                        name="name"
                        className={
                            'form-control' + (errors.name && touched.name ? ' is-invalid' : '')
                        }
                        value={values.name}
                        onChange={handleChange}
                    />
                    {errors.name && touched.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                    )}
                </div>

                <div className="form-group">
                    <label htmlFor="name">Description</label>
                    <input
                        type="text"
                        placeholder="Description"
                        name="description"
                        className={'form-control'}
                        value={values.description}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="url">URL</label>
                    <input
                        type="text"
                        placeholder="URL"
                        name="url"
                        className={
                            'form-control' + (errors.url && touched.url ? ' is-invalid' : '')
                        }
                        value={values.url}
                        onChange={handleChange}
                    />
                    {errors.url && touched.url && (
                        <div className="invalid-feedback">{errors.url}</div>
                    )}
                </div>

                <div>
                    <label>Sections</label>
                </div>
                <DocumentSectionListEditor
                    sections={values.sections}
                    onSectionChange={handleSectionChange}
                />

                <div className="form-group row mt-2 float-right">
                    <button
                        type="button"
                        onClick={this.props.close}
                        className="btn btn-secondary mb-2"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={this.canSaveDocument()}
                        className="save-document btn btn-primary mb-2 ml-2"
                    >
                        Save
                    </button>
                </div>
            </form>
        );
    };
}

DocumentEditor.propTypes = {
    save: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    document: PropTypes.object.isRequired,
};

export { DocumentEditor };
